import axios, { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios'
import { AUTH_KEY, BASE_URL } from './constant'
import toast from 'react-hot-toast'
import Cookies from 'js-cookie'

export const fetcher = (
  url: string,
  options?: RequestInit
): Promise<Response> => {
  const defaultOptions: RequestInit = {
    credentials: 'include',
    ...options,
  }

  const fullUrl = `${BASE_URL}${url}`
  return fetch(fullUrl, defaultOptions)
}

export const request = axios.create({
  baseURL: BASE_URL,
})

request.interceptors.request.use(
  async config => {
    const authToken = Cookies.get(AUTH_KEY)
    if (authToken) {
      config.headers.Authorization = `Bearer ${authToken}`
    }

    return config
  },
  error => Promise.reject(error)
)

request.interceptors.response.use(
  response => response,
  ({ response, ...error }: AxiosError<{ message: string }>) => {
    toast.error(response?.data.message || 'خطای ناشناخته')
    // if (response?.status === 401) location.replace('/login')
    Promise.reject({ request, response, error })
  }
)

const post = <R, D>(url: string, data?: D, config?: AxiosRequestConfig<D>) =>
  request.post<R, AxiosResponse<R>, D>(url, data, config)

const get = <T = never, R = AxiosResponse<T>, D = unknown>(
  url: string,
  config?: AxiosRequestConfig<D>
) => request.get<T, R, D>(url, config)

const put = <R, D>(url: string, data?: D, config?: AxiosRequestConfig<D>) =>
  request.put<R, AxiosResponse<R>, D>(url, data, config)

const patch = <R, D>(url: string, data?: D, config?: AxiosRequestConfig<D>) =>
  request.patch<R, AxiosResponse<R>, D>(url, data, config)

const del = <R, D>(url: string, config?: AxiosRequestConfig<D>) =>
  request.delete<R, AxiosResponse<R>, D>(url, config)

export const http = {
  post,
  get,
  put,
  patch,
  delete: del,
}
